import { api } from '../../config';
import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';

export const getStep = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }
  try {
    const url = `/v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/step`;
    const headers = {
      token: params.token,
    };
    const payload = {};
    const response = await api.put(url, headers, payload);
    return response.data;
  } catch (error) {
    console.log(error);
    console.error('Error getting next step:', { error, params });
    throw new ApiError(error.message);
  }
};

export const completeAndGetNextStep = async (
  journeyStepId,
  data = {},
  params = null
) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }
  try {
    const url = `/v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/step`;
    const headers = {
      token: params.token,
    };
    const payload = {
      complete: {
        journeyStepId,
        data,
      },
    };
    const response = await api.put(url, headers, payload);
    return response.data;
  } catch (error) {
    console.error('Error getting next step:', {
      error,
      journeyStepId,
      data,
      params,
    });
    throw new ApiError();
  }
};
